import React, { ReactElement, useState, useEffect } from "react";
import {
    Box,
    Avatar,
    Typography,
    Button,
    Backdrop,
    IconButton,
    TextField,
    MenuItem
} from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import createproject from "../../../../assets/createproject.svg";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import * as projectActions from "../../../../store/project";
import Close from "../../../../assets/close.svg";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import closed from "../../../../assets/close.svg";
import axios from "axios";
import { client } from "../../../../services/client";
import config from "../../../../config/config";
import logo from "../../../../assets/Refy.png";

function WelcomeScreen(props) {
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const [welcomeTxt, setWelcomeTxt] = React.useState("Highlight Box");
    const project = useSelector((state) => state.project);
    const valiateUser = useSelector((state) => state.auth?.valiateUser);
    const handleClose = async () => {
        await dispatch(projectActions?.createProjectPopupNot())
        if (valiateUser?.state === 7) {
            const authdata = await dispatch(projectActions.openBackdrop());
        }
        else if (valiateUser?.state === 5) {
            await dispatch(projectActions?.highlightCompanyDetails())
            setTimeout(async () => {
                await dispatch(projectActions?.highlightCompanyDetailsNot());
            }, 4000);

        }
        else if (valiateUser?.state === 3) {
            await dispatch(projectActions?.highlightFinancingRequirement())
            setTimeout(async () => {
                await dispatch(projectActions?.highlightFinancingRequirementNot());
            }, 4000);
        }
        else {
            await dispatch(projectActions?.highlightCompanyDetails())
            await dispatch(projectActions?.highlightFinancingRequirement())
            setTimeout(async () => {
                await dispatch(projectActions?.highlightCompanyDetailsNot());
                await dispatch(projectActions?.highlightFinancingRequirementNot());
            }, 4000);
        }

    };
    const handleOpen = () => {
        setOpen(true);
    };
    const navigate = useNavigate();
    const { uuid } = useParams();
    const user = useSelector((state) => state?.auth?.user);
    const logedIn = useSelector((state) => state?.auth?.loggedIn);

    useEffect(() => {
        if (valiateUser?.state === 5) {
            setWelcomeTxt("Company Details")
        }
        else if (valiateUser?.state === 3) {
            setWelcomeTxt("Financing Requirements")
        }
        else {
            setWelcomeTxt("Company Details and Financing Requirements")
        }
    }, [valiateUser]);

    useEffect(() => {
        const hasVisited = localStorage.getItem('welcome');
        if (!hasVisited || hasVisited === 'false') {
            setOpen(true);
            localStorage.setItem('welcome', 'true');
        }
    }, []);

    const handleSubmit = async (e) => {
    }

    function handleFocus(event) {
        event.target.style.border = 'none';
        event.target.style.outline = 'none';
    }

    return (
        <>
            <Box>
                <CssBaseline />
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        display: "flex",
                        justifyContent: "center",
                    }}
                    open={project?.createProjectpopup}
                    onClick={handleClose}
                >
                    <Box
                        sx={{
                            backgroundColor: "#fff",
                            height: "auto",
                            margin: "32px",
                            padding: "16px 16px",
                            overflowY: "auto",
                            borderRadius: "8px"
                        }}
                    >
                        <Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>

                                <Box></Box>

                            </Box>
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                width: "100%",
                                height: "calc ( 100vh - 120px)",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <CssBaseline />
                            <Box
                                sx={{
                                    display: "flex",
                                    width: { xs: "100%", sm: "800px" },
                                    p: 2,
                                    flexDirection: "column",
                                    gap: 2
                                }}
                            >


                                <Box>
                                    <Typography variant="h6" sx={{ color: "#12190F", fontWeight: "700", letterSpacing: "0.9px", fontSize: "22px" }}>
                                        Complete {welcomeTxt}
                                    </Typography>

                                </Box>



                                <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Button variant="contained"  >ok</Button>
                                </Box>


                            </Box>
                        </Box>

                    </Box>
                </Backdrop>
            </Box>
        </>
    );
}

export default WelcomeScreen;
